'use strict';

module.exports = {
    'lang': 'zh-cn',
    'msgMax': '值不能大于最大值',
    'msgMin': '值不能小于最小值',
    'en-us': {
        'msgMax': 'Cannot be greater than the Max value',
        'msgMin': 'Cannot be less than the Min value'
    },
    'zh-tw': {
        'msgMax': '值不能大於最大值',
        'msgMin': '值不能小於最小值'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/bee-input-number/build/i18n.js
// module id = 663
// module chunks = 0